module.exports = __webpack_public_path__ + "static/media/delivering_hope.d94d1f70.jpg";